import { Box, TextField, CircularProgress } from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import BaseCard from "../../../components/Cards/Card";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect, useRef, useState } from "react";
import { Toaster, toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { BASE_URL } from "../../../components/BaseUrl";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setProfileUpdateToken } from "../../../Redux/Slices/AuthSlice";
import { useTranslation } from "react-i18next";
import {showToast} from "../../../Utlis/messageHandler"
const OTPScreen = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const otpFromRedux = useSelector((state) => state.auth.otpData?.otp);
  const userId = useSelector((state) => state.auth.otpData?.userId);
  const email = useSelector((state) => state.auth.user?.email);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showError, setShowError] = useState(false);
  const [timer, setTimer] = useState(15); // 👈 start at 15 seconds immediately
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false); // 👈 new state for resend
  const inputRefs = useRef([]);

  // Timer countdown effect
  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  // Handle OTP box input
  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Resend OTP logic
  const handleResendOtp = async () => {
        setOtp(["", "", "", "", "", ""]);   // ✅ clear inputs

    if (!email) {
      toast.error(t("otpScreen.error_missing_email"));
      return;
    }

    setIsResending(true); // 👈 show loader instead of button
    try {
      const response = await fetch(`${BASE_URL}/account-executive/resend-verification-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
         if (!response.ok || data.error) {
      showToast(toast.error, data, "Failed to resend OTP");
      throw new Error();
    }

    showToast(toast.success, data, "OTP resent successfully");
      setTimer(15); // 👈 restart countdown at 15s
    } catch (err) {
    showToast(toast.error, err, t("Something went wrong"));
    } finally {
      setIsResending(false); // 👈 hide loader
    }
  };

  const handleVerify = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 6 || otp.includes("")) {
      setShowError(true); 
      toast.error(t("Please enter Valid  OTP code")); 
      return;
    }
   
    if (!userId) {
      toast.error(t("otpScreen.error_invalid_otp"));
      return;
    }

    setShowError(false); 
    setIsLoading(true);
    setTimer(15);

    try {
      const response = await fetch(
        `${BASE_URL}/public/account-executives/verify-invite?userId=${userId}&otp=${fullOtp}`,
        { method: "GET" }
      );

      const data = await response.json();
    if (!response.ok || data.error) {
      showToast(toast.error, data, "OTP verification failed");
      throw new Error();
    }

    showToast(toast.success, data, "OTP verified successfully");

      const profileToken = data.data?.profileUpdateToken;
      if (profileToken) {
        dispatch(setProfileUpdateToken(profileToken));
        localStorage.setItem("profileUpdateToken", profileToken);
      }

      setTimeout(() => {
        navigate("/create-profile");
      }, 1000);
    } catch (err) {
    showToast(toast.error, err, t("Something went wrong"));
    } finally {
      setIsLoading(false);
    }
  };

const handlePaste = (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData("text").trim();

  // Only accept digits
  if (!/^\d{1,6}$/.test(pasteData)) return;

  // Split digits and fill inputs
  const newOtp = pasteData.split("").slice(0, 6);
  setOtp(newOtp);

  // ✅ Fix: correctly reset error
  if (showError) setShowError(false);

  // Optionally move focus to last filled field
  const lastIndex = newOtp.length - 1;
  if (lastIndex >= 0) inputRefs.current[lastIndex]?.focus();
};
  return (
    <Box sx={{ backgroundColor: "#EFF4F8", pt: isMobile ? 3 : 5 }}>
      {/* <Toaster /> */}
      <Box 
        sx={{ 
          px: 2, 
          display: 'flex', 
          justifyContent: 'center',
          minHeight: "100vh",
          alignItems: "center",
        }}
      >   
        <BaseCard 
          maxWidth={isMobile ? '100%' : 380} 
          sx={{ width: isMobile ? '100%' : 'auto', px: isMobile ? 2 : 0 }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
              <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main }}>
                {t("otpScreen.enter_otp_title")}
              </CustomText>
              <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary, pt: 2 }}>
                {t("otpScreen.enter_otp_description")}
              </CustomText>
            </Box>

            {/* OTP Inputs */}
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
              {otp.map((digit, index) => (
                // <TextField
                //   key={index}
                //   inputRef={el => inputRefs.current[index] = el}
                //   value={digit}
                //        onPaste={handlePaste} 
                //   onChange={(e) => handleChange(index, e.target.value)}
                //   onKeyDown={(e) => handleKeyDown(e, index)}
                //   inputProps={{
                //     maxLength: 1,
                //     style: {
                //       textAlign: 'center',
                //       fontSize: '24px',
                //       width: '45px',
                //       height: '30px',
                //       borderRadius: '12px',
                //     },
                //   }}
                //   sx={{
                //     '& .MuiOutlinedInput-root': {
                //       borderRadius: '12px',
                //       '& fieldset': {
                //         borderColor: showError && !digit 
                //           ? 'red' 
                //           : digit 
                //             ? theme.palette.primary.main 
                //             : '#ccc',
                //       },
                //       '&.Mui-focused fieldset': {
                //         borderColor: theme.palette.primary.main,
                //         borderWidth: '2px',
                //       },
                //     },
                //   }}
                // />

                <TextField
  key={index}
  inputRef={(el) => (inputRefs.current[index] = el)}
  value={digit}
  onPaste={handlePaste}
  onChange={(e) => handleChange(index, e.target.value)}
  onKeyDown={(e) => handleKeyDown(e, index)}
  inputProps={{
    maxLength: 1,
    style: {
      textAlign: "center",
      fontSize: isMobile ? "18px" : "24px",
    },
  }}
  sx={{
    width: { xs: 40, sm: 50, md: 55 },    // responsive box width
    height: { xs: 48, sm: 55 },           // responsive height
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      "& input": {
        paddingY: 1.5,
        paddingX: 0,
      },
      "& fieldset": {
        borderColor:
          showError && !digit
            ? "red"
            : digit
            ? theme.palette.primary.main
            : "#ccc",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "2px",
      },
    },
  }}
/>

              ))}
            </Box>

            {/* Resend OTP Section */}
            <CustomText 
              sx={{ ...textStyles.body4, color: theme.palette.text.primary, textAlign: 'center' }}
            >
              {t("otpScreen.resend_text")}{" "}
              {timer > 0 ? (
                <span style={{ color: "#0066FF", fontWeight: 600 }}>
                  {timer}s
                </span>
              ) : isResending ? (
                <CircularProgress size={18} sx={{ color: "#0066FF" }} />
              ) : (
                <span
                  onClick={handleResendOtp}
                  style={{
                    color: "#0066FF",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  {t("otpScreen.resend_action")}
                </span>
              )}
            </CustomText>

            {/* Verify Button */}
            <CustomButton
              label={
                isLoading ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                    <span>{t("otpScreen.verifying")}</span>
                  </Box>
                ) : (
                  <span>{t("otpScreen.verify_button")}</span>
                )
              }
              onClick={handleVerify}
              fullWidth
              sx={{ mt: 2 }}
            />
          </Box>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default OTPScreen;










